<script setup>
import roles from '@/api/roles';
import { ref, inject } from 'vue';
import { useVModel } from '@vueuse/core';
import SelectCifra from '../inputs/SelectCifra.vue';

const props = defineProps({
  modelValue: { type: Array, default: () => ([]) },
});

const $I18n = inject('I18n');

const emits = defineEmits(['update:modelValue']);

const modelInterno = useVModel(props, 'modelValue', emits);

const options = ref([]);

roles.get().then((result) => {
  options.value = result.data;
});

</script>

<template>
  <SelectCifra
    v-model="modelInterno"
    :options="options"
    :multiple="true"
    label="nombre"
    track-by="id"
    :placeholder="$I18n.t('Seleccione')"
  >
  </SelectCifra>
</template>
